import React, { useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { viewCartData } from "../redux/slices/ViewCartSlice";

const ThankYouPage = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("SellerloginData");
    localStorage.removeItem("SellerTokenData");
    navigate("/vendor-register/");
  };

  const handleDelete = async () => {
    const SellerId = localStorage.getItem("SellerloginData");
    const confirmDelete = window.confirm(
      "Are you sure you want to delete your account?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      const response = await axios.delete(
        `${endPoint.DeleteSeller}/${SellerId}`
      );
      localStorage.removeItem("SellerloginData");
      localStorage.removeItem("SellerTokenData");
      alert("Your account has been deleted");
      navigate("/vendor-register/");
    } catch (error) {
      console.error(
        "Error deleting seller:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-blue-100 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-lg text-center">
        <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto animate-bounce" />
        <h2 className="text-3xl font-bold text-gray-800 mt-4">
          Thank You for Registering!
        </h2>

        <p className="text-gray-600 mt-3">
          Your seller account has been successfully created.
        </p>

        <p className="text-gray-600 mt-3 font-medium">
          Your KYC verification is under process and will be approved within{" "}
          <span className="text-blue-600 font-semibold">24 hours</span>. You
          will receive an email confirmation once it's completed.
        </p>

        <p className="text-gray-500 mt-3">
          Please check your registered email for updates.
        </p>

        <div className="mt-6 flex flex-col gap-4">
          <a
            href="/"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition font-medium"
          >
            Go to Dashboard
          </a>
          <button
            onClick={() => handleLogout()}
            className=" text-black transition font-medium"
          >
            Logout
          </button>
          <button
            onClick={() => handleDelete()}
            className=" text-red-500 transition font-medium"
          >
            Delete Seller Account
          </button>
        </div>

        <p className="text-gray-500 text-sm mt-4">
          Need help?{" "}
          <a href="/support" className="text-blue-500 hover:underline">
            Contact Support
          </a>
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
